/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { Resizing } from '../resizing/resizing';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { useResizing } from '../resizing/use-resizing';
